import React, {useState, useEffect} from 'react'
import { Routes, Route } from "react-router-dom";

import Navup from '../components/common/nav1';
import Footer, {Footer2} from '../components/common/footer';

import Homepage from '../PublicPages/homepage';
import AllJournalsPage from '../PublicPages/allJournalsPage';
import JournalDetailsPage from '../PublicPages/journalDetailsPage';
import Articles from '../components/journals/articles';
import Manuscript from '../PublicPages/manuscript';
import JoinAuthorPage from '../PublicPages/joinAuthorpage';
import ProcessingFees from '../PublicPages/processingFees';
import ReviewProcessPage from '../PublicPages/reviewProcessPage';
import AboutUsPage from '../PublicPages/aboutUsPage';
import JoinReviewerPage from '../PublicPages/joinReviewerPage';
import JoinEditorPage from '../PublicPages/joinEditorPage';
import RefundPolicyPage from '../PublicPages/refundPolicyPage';
import PrivacyPolicyPage from '../PublicPages/privacyPolicyPage';
import EditorPolicyPage from '../PublicPages/editorialPolicyPage';
import PublicationEthicsPage from '../PublicPages/publicationEthicsPage';
import ResearchEthicsPage from '../PublicPages/researchEthicsPage';
import ReviewerPolicyPage from '../PublicPages/reviewerPolicyPage';
import EditorGuidlinesPage from '../PublicPages/editorialGuidlinesPage';
import ReviewerGuidlinesPage from '../PublicPages/reviewerGuidlinesPage';
import ContactUsPage from '../PublicPages/contactUsPage';
import TermsPage from '../PublicPages/termsPage';
import AuthorResponsibilityPage from '../PublicPages/authorsResponsibilityPage.js';

import AuthorInstructionPage from '../PublicPages/authorInstructionsPage';
import OpenAccessPage from '../PublicPages/openAccessPage';
import ManuBtn from '../components/common/manuButton';

import Payment from '../components/payment/payment.js';
import Checkout from '../components/payment/checkout.js';

import Login from '../AdminPages/form/login';

import api from '../API/api';
import { JournalContext } from '../Helper/Contex';

const PublicInterface = () => {

    const [journals, setJournals] =useState();
    const [topEditors, setTopEditors] =useState();
    const [indexings, setIndexings] =useState();
    const [load, setLoad] = useState(false);
    useEffect(() => {
        getJournals()
    }, []);
    const getJournals = () => {
        setLoad(true)
        api.getJournals()
            .then((res => {
                setLoad(false);
                console.log("==>", res);
                setJournals(res.data.journals);
                setTopEditors(res.data.topEditors);
                setIndexings(res.data.indexings);
            }))
            .catch((err) => {
                console.log(err.response);
            })
    }

    useEffect(()=>{
        visitor();
    }, []);

    const visitor=()=>{
        api.visitor()
        .then((res)=>{
            console.log("Count==>", res);
        })
        .catch((err)=>{
            console.log(err.response);
        })
    }


    return (
        <JournalContext.Provider value={{journals, setJournals, topEditors, indexings}}>
            <ManuBtn/>

            <Navup />

            <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/AllJournals" element={<AllJournalsPage />} />
                <Route path="/journal/:journal" element={<JournalDetailsPage />} />
                <Route path="/Articles/:Articles" element={<Articles />} />
                <Route path="/manuscript" element={<Manuscript />} />
                <Route path="/open-access-policy" element={<OpenAccessPage />} />

                <Route path="/author-instruction" element={<AuthorInstructionPage />} />
                <Route path="/joinAuthor" element={<JoinAuthorPage />} />
                <Route path="/processingFees" element={<ProcessingFees />} />
                <Route path="/reviewProcess" element={<ReviewProcessPage />} />
                <Route path="/aboutUs" element={<AboutUsPage />} />
                <Route path="/JoinReviewer" element={<JoinReviewerPage />} />
                <Route path="/JoinEditor" element={<JoinEditorPage />} />
                <Route path="/RefundPolicy" element={<RefundPolicyPage />} />
                <Route path="/PrivacyPolicy" element={<PrivacyPolicyPage />} />
                <Route path="/EditorPolicy" element={<EditorPolicyPage />} />
                <Route path="/PublicationEthics" element={<PublicationEthicsPage />} />
                <Route path="/ResearchEthics" element={<ResearchEthicsPage />} />
                <Route path="/ReviewerPolicy" element={<ReviewerPolicyPage />} />
                <Route path="/EditorGuidlines" element={<EditorGuidlinesPage />} />
                <Route path="/ReviewerGuidlines" element={<ReviewerGuidlinesPage />} />
                <Route path="/ContactUs" element={<ContactUsPage />} />
                <Route path="/TermsAndConditions" element={<TermsPage />} />
                <Route path="/AuthorResponsibility" element={<AuthorResponsibilityPage />} />



                <Route path="/Payment" element={<Payment />} />
                <Route path="/Checkout" element={<Checkout />} />
                <Route path="/Login" element={<Login />} />

            </Routes>


            <Footer2 />
        </JournalContext.Provider>
    )
}

export default PublicInterface